import { FC, JSX } from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { SwitchSetting } from '../Settings';

import LinkButton from './LinkButton';
import { ContentStyles } from '@/entities/content/api/types';

interface Props {}

const LinkButtonSettings: FC<Props> = (): JSX.Element => {
  const formMethods = useFormContext<ContentStyles>();
  const { watch } = formMethods;
  const showLinkButton = watch('config.link_button.enabled');

  return (
    <div className="flex flex-col gap-2">
      <SwitchSetting
        title="Link button"
        name="config.link_button.enabled"
        type="group"
      />

      <div
        className={twMerge(
          'flex flex-col gap-2',
          showLinkButton ? '' : 'hidden'
        )}
      >
        <LinkButton />
      </div>
    </div>
  );
};

export default LinkButtonSettings;
